import { GraphResolverBase } from './GraphResolverBase';
import { ComponentFactory, ViewContainerRef } from '@angular/core';
import { ConfigDataService } from '../services/config-data.service';
import { GraphDataService } from '../services/graph-data-service.service';
import { ViewPeriodService } from '../services/view-period.service';
import { Subscription, combineLatest, BehaviorSubject } from 'rxjs';
import { DynamicNumberCardComponent } from '../shared-components/dynamic/dynamic-number-card/dynamic-number-card.component';
import { PopoverController } from '@ionic/angular';
import { DynamicGraphAdditionalInput } from '../objects/config';
import { getAdditionalInput } from '../helpers/DynamicGraphHelper';

export class FloorHeadcountNumberCardResolver extends GraphResolverBase {

    public async createComponent(
        componentFactory: ComponentFactory<unknown>,
        additionalInput: string | DynamicGraphAdditionalInput | undefined,
        configDataService: ConfigDataService,
        graphDataService: GraphDataService,
        _popoverController: PopoverController,
        _viewPeriodService: ViewPeriodService,
        viewContainerRef: ViewContainerRef,
        subscription: Subscription
    ) {
        // load data here
        graphDataService.baseGraphData.addDependency(this.dataDependency); // ENTRANCE_EXIT, ENTRANCE_EXIT_FLOOR, ENTRANCE_EXIT_FLOW_ZONE

        // await configDataService.loadAppConfig();
        const buildingName = (getAdditionalInput(additionalInput, 'building') || configDataService.MAIN_BUILDING) as string;
        const zoneName = graphDataService.baseGraphData.selectedDirectory$.value?.zone || (getAdditionalInput(additionalInput, 'zone')) as string;
        const componentRef = viewContainerRef.createComponent(componentFactory);
        const comInstance = componentRef.instance as DynamicNumberCardComponent;

        const numberData$ = new BehaviorSubject('0');
        const label$ = new BehaviorSubject('0 % (0)');
        const labelIcon$ = new BehaviorSubject('trending-up');
        const labelStyle$ = new BehaviorSubject({ fontSize: '16px', fontWeight: '500', color: '#5BBF93' });

        subscription.add(combineLatest([graphDataService.selectedFloorName$, graphDataService.baseGraphData.selectedDirectory$, 
            configDataService.isEntranceDataMode$, graphDataService.currentBuildingHeadCountData$, graphDataService.currentBuildingHeadCountFloorData$, graphDataService.currentBuildingHeadCountZoneData$]).subscribe(
            ([selectedFloorName, selectedDirectory, isEntrance, allData, floorData, zoneData]) => {
                if (!allData || !floorData) { return; }
                const floorName = selectedDirectory?.floor || selectedFloorName || 'ALL';
                const isAll = floorName === 'ALL';
                const nextZoneName = selectedDirectory?.zone || zoneName;
                const currentData = isAll ? allData?.[buildingName] : (!nextZoneName ? floorData?.[buildingName]?.[floorName] : zoneData?.[buildingName]?.[floorName]?.[nextZoneName]);
                if (!currentData) { return; }
                const headCountData = isEntrance ? currentData.entrance : currentData.exit;
                if (!headCountData) { return; }
                numberData$.next(headCountData.headCount?.toLocaleString());
                label$.next(`${headCountData.diffPercent?.toFixed(1)} % (${headCountData.diff?.toLocaleString()})`);
                labelIcon$.next(headCountData.diff > 0 ? 'trending-up' : 'trending-down');
                labelStyle$.next({ fontSize: '16px', fontWeight: '500', color: headCountData.diff >= 0 ? '#5BBF93' : '#E25144' });
                // comInstance.isShow = !(nextZoneName) ? true : false;
            }
        ));

        comInstance.isLock = this.isLock;
        // comInstance.isShow = !(zoneName) ? true : false;
        comInstance.isShow = true;
        comInstance.title = configDataService.DISPLAY_LANGUAGE.HEADCONT;
        comInstance.numberData$ = numberData$;
        comInstance.label$ = label$;
        comInstance.labelIcon$ = labelIcon$;
        comInstance.labelStyle$ = labelStyle$;
        return comInstance;
    }

}
